<div id="refactor-text" class="m-3">

    <h1>Resumir / parafrasear texto</h1>

    <div id="text-action">
        <p class="fw-bold">¿Qué desea hacer con el texto?</p>
        <label for="text-action-summarize" class="d-block">
            <input type="radio" name="text-action" id="text-action-summarize" value="summarize" [(ngModel)]="textAction">
            <span>Resumir</span>
        </label>
    
        <label for="text-action-paraphrase" class="d-block">
            <input type="radio" name="text-action" id="text-action-paraphrase" value="paraphrase" [(ngModel)]="textAction">
            <span>Parafrasear</span>
        </label>
    </div>
    
    <div id="text-source">
        <p class="fw-bold">¿De dónde viene el texto?</p>
        <label for="text-source-heading" class="d-block">
            <input type="radio" name="text-source" id="text-source-heading" value="heading" [(ngModel)]="textSource" (ngModelChange)="refactorTextBtnDisabled = true">
            <span>De un enunciado del curso</span>
        </label>

        <label for="text-source-text" class="d-block">
            <input type="radio" name="text-source" id="text-source-text" value="text" [(ngModel)]="textSource" (ngModelChange)="refactorTextBtnDisabled = false">
            <span>Es un texto indepediente</span>
        </label>
    </div>

    <div id="text-source-heading" *ngIf="textSource === 'heading'">
        <label for="course-units" class="d-block" *ngIf="courseUnits.length > 0">
            <p class="fw-bold">Unidad:</p>
            <select #courseUnitsSelect name="course-units" id="course-units"  
            [(ngModel)]="selectedUnit" (ngModelChange)="selectUnit($event)">
                <option disabled selected value="-1">Seleccione una unidad...</option>
                <option *ngFor="let unit of courseUnits" [value]="unit.id">
                    {{ unit.name }}
                </option>
            </select>
        </label>

        <label for="units-lessons" class="d-block" *ngIf="unitLessons.length > 0">
            <p class="fw-bold">Lección:</p>
            <select #unitLessonsSelect name="unit-lessons" id="unit-lessons" 
            [(ngModel)]="selectedLesson" (ngModelChange)="selectLesson($event)">
                <option disabled selected value="-1">Seleccione una lección...</option>
                <option *ngFor="let lesson of unitLessons" [value]="lesson.id">
                    {{ lesson.name }}
                </option>
            </select>
        </label>

        <label for="lesson-headings" class="d-block" *ngIf="lessonHeadings.length > 0">
            <p class="fw-bold">Enunciado:</p>
            <select #lessonHeadingsSelect name="lesson-headings" id="lesson-headings" 
            [(ngModel)]="selectedHeading" (ngModelChange)="selectHeading($event)">
                <option disabled selected value="-1">Seleccione un enunciado...</option>
                <option *ngFor="let heading of lessonHeadings" [value]="heading.id">
                    {{ heading.name }}
                </option>
            </select>
        </label>

        <label for="heading-text-editor" class="d-block" *ngIf="selectedHeading > 0">
            <p class="fw-bold">Contenido:</p>
            <tinymce-editor [id]="'heading-text-editor'" [content]="text"></tinymce-editor>
        </label>
    </div>

    <div id="text-source-text" *ngIf="textSource === 'text'">
        <label for="text" class="d-block">
            <p class="fw-bold">Texto:</p>
            <tinymce-editor [id]="textSourceEditorId" [content]="text" [focus]="true"></tinymce-editor>
        </label>
    </div>

    <div id="refactor-text-options-summarize" *ngIf="selectedHeading > 0 || textSource === 'text'">

        <div id="refactor-text-options-summarize" *ngIf="textAction === 'summarize'">
            <p class="fw-bold">Puede elegir resumir por porcentaje de oraciones o por número de palabras. Sólo es necesario elegir uno de los dos parámetros. Si se eligen ambos, se le dará prioridad al número de palabras.</p>
            <label for="sentenceRatio" class="d-block">
                <p class="fw-bold">Porcentaje de oraciones (%):</p>
                <input type="number" [(ngModel)]="sentenceRatio" min="0" max="100">
            </label>
            <label for="numWords" class="d-block">
                <p class="fw-bold">Número aproximado de palabras:</p>
                <input type="number" [(ngModel)]="numWords" min="0">
            </label>
        </div>

        <div id="refactor-text-options-paraphrase" *ngIf="textAction === 'paraphrase'">
            <label for="maxLength" class="d-block">
                <p class="fw-bold">Longitud máxima del texto generado, en caracteres:</p>
                <input type="number" [(ngModel)]="maxLength" min="100">
            </label>
            <p class="fw-bold mt-3">OJO: El proceso de paráfrasis tarda considerablemente más tiempo que el de resumir. Por favor, espere hasta que termine.</p>
        </div>

    </div>

    <div id="refactor-text-status" class="mt-3">
        <div id="refactor-text-spinner" *ngIf="refactoringText">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="refactor-text-error" class="text-danger" *ngIf="refactorTextError">
            <i class="fa fa-times"></i>
            <span>Hubo un problema, no se pudo generar la paráfrasis. Inténtelo de nuevo con otro texto u otro límite de palabras.</span>
        </div>
        <div id="refactor-text-success" class="text-success" *ngIf="refactorTextSuccess">
            <i class="fa fa-check"></i>
            <span>{{ refactorResultMsg }}</span>
            <!-- Ahora será redireccionado, espere un momento... -->
        </div>
    </div>

    <div id="refactor-text-result" [class.d-none]="!refactorTextSuccess" class="mt-3">
        <p class="fw-bold">Resultado:</p>
        
        <div id="refactor-text-result-paraphrase-options" *ngIf="textAction === 'paraphrase'">
            <p class="fw-bold">Seleccione un resultado:</p>
            <label for="refactored-text-option1" class="d-block">
                <input type="radio" class="me-1" name="refactored-text-options" id="refactored-text-option1" [attr.checked]="refactoredText == refactoredTextOption1 ? 'checked' : null" (change)="refactoredText = refactoredTextOption1">
                <span>{{ refactoredTextOption1 }}</span>
            </label>
    
            <label for="refactored-text-option2" class="d-block">
                <input type="radio" class="me-1" name="refactored-text-options" id="refactored-text-option2" [attr.checked]="refactoredText == refactoredTextOption2 ? 'checked' : null" (change)="refactoredText = refactoredTextOption2">
                <span>{{ refactoredTextOption2 }}</span>
            </label>
    
            <label for="refactored-text-option3" class="d-block">
                <input type="radio" class="me-1" name="refactored-text-options" id="refactored-text-option3" [attr.checked]="refactoredText == refactoredTextOption3 ? 'checked' : null" (change)="refactoredText = refactoredTextOption3">
                <span>{{ refactoredTextOption3 }}</span>
            </label>
    
            <label for="refactored-text-option4" class="d-block">
                <input type="radio" class="me-1" name="refactored-text-options" id="refactored-text-option4" [attr.checked]="refactoredText == refactoredTextOption4 ? 'checked' : null" (change)="refactoredText = refactoredTextOption4">
                <span>{{ refactoredTextOption4 }}</span>
            </label>
        </div>

        <label for="refactored-text-editor" class="d-block" *ngIf="refactoredText != ''">
            <p class="fw-bold">Texto generado:</p>
            <tinymce-editor [id]="refactoredTextEditorId" [content]="refactoredText" [focus]="false"></tinymce-editor>
        </label>
    </div>

    <div id="update-heading-status" class="mt-3" [class.d-none]="!refactorTextSuccess">
        <div id="update-heading-spinner" *ngIf="updatingHeading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="update-heading-error" class="text-danger" *ngIf="updateHeadingError">
            <i class="fa fa-times"></i>
            <span>Hubo un problema al actualizar el enunciado. Inténtelo de nuevo.</span>
        </div>
        <div id="update-heading-success" class="text-success" *ngIf="updateHeadingSuccess">
            <i class="fa fa-check"></i>
            <span>¡Enunciado actualizado correctamente!</span>
            <!-- Ahora será redireccionado, espere un momento... -->
        </div>
    </div>

    <div id="refactor-text-buttons" class="row">
        <button class="btn btn-primary m-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success m-3" *ngIf="textAction === 'summarize'" [attr.disabled]="refactorTextBtnDisabled ? 'disabled' : null" (click)="summarizeText()">
            <i class="fas fa-align-center"></i>
            <span>Resumir texto</span>
        </button>
        <button class="btn btn-success m-3" *ngIf="textAction === 'paraphrase'" [attr.disabled]="refactorTextBtnDisabled ? 'disabled' : null"
            (click)="paraphraseText()">
            <i class="fas fa-align-center"></i>
            <span>Parafrasear texto</span>
        </button>
        <button class="btn btn-success m-3" *ngIf="textSource === 'heading' && refactorTextSuccess" [attr.disabled]="updateHeadingBtnDisabled ? 'disabled' : null" (click)="updateHeading()">
            <i class="fas fa-save"></i>
            <span>Actualizar enunciado</span>
        </button>
    </div>
</div>